import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { TemplateEntryAppointmentItemDataFragment } from '../../data/types/api/graphql';
import { ButtonIcon } from '../button/button';
import { TemplateEntryAppointmentListItem } from './template-entry-appointment-list-item';

type TemplateEntryAppointmentListProps = {
  items: TemplateEntryAppointmentItemDataFragment[];
  actions?: {
    icon?: ButtonIcon;
    onClick: (value: string) => void;
  }[];
  onClick?: (value: TemplateEntryAppointmentItemDataFragment) => void;
};

export function TemplateEntryAppointmentList({
  actions = [],
  onClick,
  ...props
}: TemplateEntryAppointmentListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (isEmpty(items)) return null;

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <TemplateEntryAppointmentListItem
            templateEntryAppointmentItem={option}
            actions={actions}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
